import axios from "axios";
import React, { useEffect, useState } from "react";
import { Config } from "../../../../../Config";
import UploadWidget from "./Components/UploadWidget";

const Trainings = (props) => {
  const [UploadCount, setUploadCount] = useState(0);
  const [UploadInProgress, setUploadInProgress] = useState(false);
  const [TrainingsHasError, setTrainingHasError] = useState(false);
  const [TrainingEmpHasError, setTrainingEmpHasError] = useState(false);
  const [TrainingPosHasError, setTrainingPosHasError] = useState(false);
  const [DevProgramHasError, setDevProgramHasError] = useState(false);

  var CheckFileCountTimer;

  useEffect(() => {
    CheckFileCountTimer = setInterval(updatePrevFileCount, 100);
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const validateFileSize = (FileSize, Id) => {
    setTimeout(() => {
      if (FileSize <= 1) {
        document.getElementById(Id).innerHTML = translateText(
          "data_import_widget_error_non_empty"
        );
      }
    }, 100);
  };

  // this function is called after each file is uploaded inside the then promise, to
  // check the uploaded file extension and in case it is wrong (non-csv) it will set an
  // innerHTML for the error <p></p> tag with the relevant Id. FileName and ErrorElementId
  // are passed down as params to the function call and are different for each upload widget and
  // each uploaded file.
  const validateUploadedFileExtension = (FileName, ErrorElementId) => {
    let FileExtention = FileName.slice(FileName.indexOf("."), FileName.length);

    if (document.getElementById(ErrorElementId) !== null) {
      if (FileExtention !== ".csv") {
        document.getElementById(ErrorElementId).innerHTML =
          "Please upload a csv file.";
      }
    }
  };

  const updatePrevFileCount = () => {
    var Count = 0;
    for (let i = 1; i < 5; i++) {
      if (
        document.getElementById("csv-" + i + "-check") !== null &&
        document
          .getElementById("csv-" + i + "-check")
          .classList.contains("feather-check")
      ) {
        Count++;
      }
    }
    if (Count === 4) {
      clearInterval(CheckFileCountTimer);
    }
    setUploadCount(Count);
  };

  const handleUploadEnd = () => {
    setTimeout(() => {
      updatePrevFileCount();
    }, 300);
  };

  // Trainings.csv file upload handler
  const uploadTrainingsCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-1-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL + Config.DataImportURL + "/api/training/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-1-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setTrainingHasError(false);
        } else {
          setTrainingHasError(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-1-error");
      })
      .catch((Err) => {
        console.log(Err.response);
        setTrainingHasError(true);
      });
  };

  // TrainingEmp.csv file upload handler
  const uploadTrainingEmpCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-2-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/training-employee/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-2-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setTrainingEmpHasError(false);
        } else {
          setTrainingEmpHasError(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-2-error");
      })
      .catch((Err) => {
        console.log(Err.response);
        setTrainingEmpHasError(true);
      });
  };
  // TrainingPos.csv file upload handler
  const uploadTrainingPosEmpCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-3-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/training-position/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-3-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setTrainingPosHasError(false);
        } else {
          setTrainingPosHasError(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-3-error");
      })
      .catch((Err) => {
        console.log(Err.response);
        setTrainingPosHasError(true);
      });
  };

  // DevProgram.csv file upload handler
  const uploadDevProgramEmpCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-4-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/development-program/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-4-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setDevProgramHasError(false);
        } else {
          setDevProgramHasError(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-4-error");
      })
      .catch((Err) => {
        console.log(Err.response);
        setDevProgramHasError(true);
      });
  };

  return (
    <div className="simple-form">
      <section className="form-head">
        <h1>
          {translateText("trainings_files")}
          <p className="opt-info">{"(" + translateText("optional") + ")"}</p>
        </h1>
      </section>
      <div className="form-body">
        <p className="info-top">
          {UploadCount +
            " " +
            translateText("of") +
            " " +
            "4 " +
            translateText("files_uploaded_successfully")}
        </p>
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadTrainingsCSV()}
          Enum={"TRAINING"}
          API_Name={"training"}
          UploadHadErrors={TrainingsHasError}
          SwitchErrorState={() => setTrainingHasError(!TrainingsHasError)}
          Placeholder="Trainings.csv"
          Id="csv-1"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setTrainingHasError(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadTrainingEmpCSV()}
          Enum={"TRAINING_EMPLOYEE"}
          API_Name={"training-employee"}
          UploadHadErrors={TrainingEmpHasError}
          SwitchErrorState={() => setTrainingEmpHasError(!TrainingEmpHasError)}
          Placeholder="TrainingEmp.csv"
          Id="csv-2"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setTrainingEmpHasError(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadTrainingPosEmpCSV()}
          Enum={"TRAINING_POSITION"}
          API_Name={"training-position"}
          UploadHadErrors={TrainingPosHasError}
          SwitchErrorState={() => setTrainingPosHasError(!TrainingPosHasError)}
          Placeholder="TrainingPos.csv"
          Id="csv-3"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setTrainingPosHasError(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadDevProgramEmpCSV()}
          Enum={"DEVELOPMENT_PROGRAM"}
          API_Name={"development-program"}
          UploadHadErrors={DevProgramHasError}
          SwitchErrorState={() => setDevProgramHasError(!DevProgramHasError)}
          Placeholder="DevProgram.csv"
          Id="csv-4"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setDevProgramHasError(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          LangData={props.LangData}
        />
      </div>
    </div>
  );
};
export default Trainings;
